import React from 'react';
import { Container, Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="footer mt-auto py-3 bg-light">
      <Container className="text-center">
        <Nav className="justify-content-center">
          <Nav.Item>
            <Nav.Link as={Link} to="/about">About Us</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link as={Link} to="/legal">Privacy Policy</Nav.Link>
          </Nav.Item>
          <Nav.Item>
            <Nav.Link as={Link} to="/legal">Terms of Service</Nav.Link>
          </Nav.Item>
        </Nav>
        <span className="text-muted">© 2025 ComRelAI. All Rights Reserved.</span>
      </Container>
    </footer>
  );
};

export default Footer;
